import React, { useContext, useEffect, useState } from 'react'
import { LocaleContext } from '../../contexts/LocaleContext';
import { params } from '../../config/params';
import { searchParams } from '../../config/searchParams';
import { urlConfig } from '../../config/baseUrl';
import InLinneLoading from '../../components/common/InlineLoading';
import Pagination from '../../components/Pagination';
import { toast } from '../../services/toastService';
import Loading from '../../components/common/Loading';
import { Link, useParams } from 'react-router-dom';
import DeleteConfirmation from '../../components/DeleteConfirmation';
import { cityService } from '../../services/cityService';
import { countryService } from '../../services/countryService';
import BackButton from '../../components/common/BackButton';

const CountryCities = () => {
  const { t,lang } = useContext(LocaleContext);
  const { countryId } = useParams();
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [country, setCountry] = useState(null);
  const [loadingId, setLoadingId] = useState(null);
  const [deleteCityId, setDeleteCityId] = useState(null);

  useEffect(() => {
        setLoading(true);
        params.pageNumber = 1;
        getAllAsync();
        loadCountryAsync();
      }, [countryId]);

      const loadCountryAsync = async () => {
        try {
          var response = await countryService.edit(countryId);
          if (response.isSuccess) {
            setCountry(response.value);
          }
        } catch (err) {
          console.error(err);
        }
      };

      const getAllAsync = async () => {
        try {
          var data = await cityService.getAllByCountryAsync(countryId, params);
          setData(data);
        } catch (err) {
          console.error(err);
        } finally {
          setLoading(false);
        }
      };
      const getAllSearchAsync = async (signal) => {
        try {
          var data = await cityService.getAllSearchAsync(
            { ...searchParams, countryId },
            signal,
          );
          setData(data);
        } catch (err) {
          console.log(err);
        } finally {
          setLoading(false);
        }
      };
      // 🟢 Search effect with debounce & cancel
      useEffect(() => {
        if (search.trim().length < 2) {
          params.pageNumber = 1;
          getAllAsync(); // reset to default if search is cleared
          return;
        }

        const controller = new AbortController(); // cancel token
        const delay = setTimeout(() => {
          searchParams.search = search.trim(); // update global params
          searchParams.pageNumber = 1; // reset page to 1 on search
          getAllSearchAsync(controller.signal);
        }, 400); // debounce time

        return () => {
          controller.abort(); // cancel previous request
          clearTimeout(delay); // clear debounce
        };
      }, [search]);
      const onPageChange = async (pageNumber) => {
        setLoading(true);
        if (!search) {
          params.pageNumber = pageNumber;
          getAllAsync();
          return;
        }
        searchParams.pageNumber = pageNumber;
        await getAllSearchAsync();
      };
      const handleChecked = async (id) => {

              setLoadingId(id);

              const previousData = data;

              try {

                // ✅ IMPORTANT: use data.items
                const safeItems = Array.isArray(data?.items) ? data.items : [];

                const updatedItems = safeItems.map((item) =>
                  item.id === id ? { ...item, isActive: !item.isActive } : item,
                );

                // ✅ keep pagination structure intact
                setData({
                  ...data,
                  items: updatedItems,
                });

                const response = await cityService.toggleActivate(id);

                if (!response.isSuccess) {
                  setData(previousData);
                  response.key
                    ? toast.error(t(response.key))
                    : toast.error(t("anErrorOccurredPleaseTryAgainLater"));
                    console.log(response);
                  return;
                }

                toast.success(t("recordUpdatedSuccessfully"));
              } catch (error) {
                setData(previousData);
                toast.error(t("anErrorOccurredPleaseTryAgainLater"));
                console.log(error);
              } finally {
                setLoadingId(null);
              }
            };
      const handleDelete=async ()=>{
        try {
          if(!deleteCityId)
          {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            return;
          }
          setLoading(true);
          var response = await cityService.deleteAsync(deleteCityId);
          if (!response.isSuccess) {
            toast.error(t("anErrorOccurredPleaseTryAgainLater"));
            console.log(response);
            return;
          }
          toast.success(t("recordDeletedSuccessfully"));
          getAllAsync();
        } catch (error) {
          const message = error.response?.data?.[0] || "";
                console.log(message);
          
                if (message.includes("linked trips")) {
                  toast.error(t("linkedTrips"));
                  return;
                }
          
                toast.error(t("anErrorOccurredPleaseTryAgainLater"));
        }
        finally{
          setLoading(false);
        }
      }
  return (
    <>
      {loading && <Loading />}
      <section className="section-categories">
        <div className="default-heading d-flex justify-content-between align-items-center">
          <span>{t("cities")} {country ? `- ${country.name}` : ""}</span>
          <BackButton />
        </div>
        <section className="section-grid">
          <div className="grid-card">
            <div className="grid-card-header">
              <strong>{t("cityManagement")}</strong>
              <p>{t("viewAndManageAllCitiesInTheSystem")}</p>
            </div>
            <div className="grid-card-body">
              <div className="table-header">
                <div className="table-header-icons hidden">
                  <div className="icon-box">
                    <i className="fas fa-file-pdf"></i>
                  </div>
                  <div className="icon-box">
                    <i className="fas fa-file-excel"></i>
                  </div>
                  <div className="icon-box">
                    <i className="fas fa-print"></i>
                  </div>
                </div>
                <div className="table-search">
                  <div className="input-icon input-icon-width">
                    <input
                      type="text"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="form-control input-search"
                      placeholder={t("search")}
                    />
                    <i className="fas fa-search"></i>
                  </div>
                  <div className="grid-btn">
                    <Link to={`/countries/${countryId}/city-form`}>
                      <button className="btn-default my-bg-secondary">
                        <i className="fas fa-plus"></i> {t("addNewCity")}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-delete-option mt-3">
                <b>{t("allCities")}</b>
              </div>
              <div className="my-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th>
                        <input type="checkbox" />
                      </th>
                      <th>{t("image")}</th>
                      <th>{t("name")}</th>
                      <th>{t("nameEn")}</th>
                      <th>{t("status")}</th>
                      <th>{t("noOfTrips")}</th>
                      <th>{t("date")}</th>
                      <th>{t("actions")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.items?.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <input type="checkbox" />
                        </td>
                        <td className="flex-center">
                          <div className="grid-image">
                            <img
                              src={`${urlConfig.imageBaseUrl}/${item.imagePath}`}
                              alt="City"
                            />
                          </div>
                        </td>
                        <td>{item.name}</td>
                        <td>{item.nameEn}</td>
                        <td>
                          {loadingId === item.id ? (
                            <InLinneLoading color={"text-primary"} />
                          ) : (
                            <div className="form-check form-switch flex-center">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`switch-${item.id}`}
                                checked={item.isActive}
                                onChange={() => handleChecked(item.id)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`switch-${item.id}`}
                              ></label>
                            </div>
                          )}
                        </td>
                        <td>{item.noOfTrips}</td>
                        <td>{item.createdAt?.toDate()}</td>
                        <td>
                          <i
                            class="fas fa-ellipsis-vertical"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          ></i>
                          <ul className="dropdown-menu">
                            <li>
                              <a
                                className="dropdown-item"
                                href={`/countries/${countryId}/city-form/${item.id}`}
                              >
                                <i className="fas fa-edit"></i> {t("edit")}
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setDeleteCityId(item.id);
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#my-modal"
                              >
                                <i className="fas fa-trash-alt text-danger"></i>{" "}
                                {t("delete")}
                              </a>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    ))}
                    {data?.items?.length === 0 && (
                      <tr>
                        <td colSpan="100%" className="text-center py-3">
                          {t("noResultsFound")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="grid-footer">
              {data && (
                <Pagination
                  t={t}
                  pageNumber={data.pageNumber}
                  totalPages={data.totalPages}
                  hasNextPage={data.hasNextPage}
                  hasPreviousPage={data.hasPreviousPage}
                  onPageChange={onPageChange}
                />
              )}
            </div>
          </div>
        </section>
      </section>
      <DeleteConfirmation t={t} handleDelete={handleDelete} />
    </>
  );
};

export default CountryCities
